/*
 * Ce code pour gérer le bouton "..." (En savoir plus)
 */

document.addEventListener("DOMContentLoaded", () => {
  const btn = document.querySelector(".toggle-btn");
  const content = document.querySelector(".toggle-content");

  if (!btn || !content) return;

  btn.addEventListener("click", () => {
    const isHidden = content.style.display === "none";
    content.style.display = isHidden ? "block" : "none";
    btn.textContent = isHidden ? " x " : " ... ";
  });
});